import {UserDB} from '@/services/db'
import i18n from '@/i18n/index'
import bookSync from '@/services/booksync'

const db = new UserDB()

const setZoomLevel = async ({ commit, rootState }, zoomLevel) => {
  commit('SET_ZOOM_LEVEL', zoomLevel)

  const data = {
    bookIdKey: rootState.book.book._id + 'zoomLevel',
    key: 'zoomLevel',
    value: zoomLevel
  }

  await db.bookPreferences.put(data)
}

const setLibraryFilter = ({ commit }, filter) => {
  commit('SET_LIBRARY_FILTER', filter)
}

const setLibraryLoaded = ({ commit }, load) => {
  commit('SET_LIBRARY_LOADED', load)
}

const setLibraryScrollPos = ({ commit }, load) => {
  commit('SET_LIBRARY_SCROLL_POS', load)
}

const setPagesPerView = async ({ commit, rootState }, pagesPerView) => {
  commit('SET_PAGES_PER_VIEW', pagesPerView)

  const data = {
    bookIdKey: rootState.book.book._id + 'pagesPerView',
    key: 'pagesPerView',
    value: pagesPerView
  }

  await db.bookPreferences.put(data)
}

const setLastReadPage = async ({ commit, rootState }, lastReadPage) => {
  commit('SET_LAST_READ_PAGE', lastReadPage)

  const data = {
    book: rootState.book.book._id,
    key: 'last_viewed_page',
    value: lastReadPage.page
  }

  const dataIDB = {
    bookIdKey: rootState.book.book._id + 'lastReadPage',
    key: 'lastReadPage',
    value: {page: lastReadPage.page, id: lastReadPage.id, created: lastReadPage.created}
  }

  await bookSync.getLastReadPage(rootState.user.accessToken, rootState.book.book._id).then(async (response) => {
    if(response && response.objects.length) {
      await bookSync.updateLastReadPage(rootState.user.accessToken, data, response.objects[0].id)
    } else {
      await bookSync.addLastReadPage(rootState.user.accessToken, data)
    }
  })

  await db.bookPreferences.put(dataIDB)
}

const setLocale = async ({ commit }, locale) => {
  commit('SET_LOCALE', locale)

  const data = {
    key: 'locale',
    value: locale
  }

  await db.appSettings.put(data)
  i18n.locale = locale
}

const setDictLang = async ({ commit }, lang) => {
  commit('SET_DICT_LANG', lang)

  const data = {
    key: 'lang',
    code: lang.code,
    name:  lang.name
  }

  await db.appSettings.put(data)
}

const setLibraryFilterOffline = ({commit}, payload) => {
  commit('SET_LIBRARY_FILTER_OFFLINE', payload)
}

const clearSettings = ({ commit }) => {
  commit('CLEAR_SETTINGS')
}

const detectConnection = ({ commit }) => {
  let isConnected
  navigator.onLine ? isConnected = true : isConnected = false;

  window.addEventListener('online', () => {
    isConnected = true
    commit('SET_CONNECTION', isConnected)
  })
  window.addEventListener('offline', () => {
    isConnected = false
    commit('SET_CONNECTION', isConnected)
  })

  commit('SET_CONNECTION', isConnected)
}

const setBubbleAcceptance = async ({ commit }, bubbleAccepted) => {
  commit('SET_BUBBLE_ACCEPTANCE', bubbleAccepted)

  const data = {
    key: 'bubbleAccepted',
    value: bubbleAccepted
  }
  await db.appSettings.put(data)

}

const setResponsive = ({ commit }, value) => {
  commit('SET_RESPONSIVE', value)
}

export default {
  setZoomLevel,
  setPagesPerView,
  setLastReadPage,
  setLocale,
  setDictLang,
  setLibraryFilter,
  setLibraryLoaded,
  setLibraryScrollPos,
  setLibraryFilterOffline,
  clearSettings,
  detectConnection,
  setBubbleAcceptance,
  setResponsive
}
